import './app-descr.scss';

const AppDescr = () => {

    return (
        <div className="app-descr">
            <h2>Образец!</h2>
            <p>Данное приложение позволяет вести учет, фильтровать, добавлять и удалять сотрудников, устанавливать зарплату и должность,  а также отмечать избранных и выделять для премирования определенных сотрудников компании. На данный момент здесь представлена лишь малая часть реализации самого приложения. Создано при помощи библиотеки React.</p>
        </div>
    )
}

export default AppDescr;